export const outsideCommissionsColor = '#1a4a95';

export const standardDeductionsColor = '#ff8f00';

export const emptyChartColor = '#eeeef1';

export const brokerColors = [
  '#b976e9',
  '#d3ed31',
  '#2dc2eb',
  '#38b698',
  '#5e26ff',
  '#ffc2fa',
  '#618cb6',
  '#040f2f',
  '#f7b500',
  '#f26691',
];
